import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: 'AIzaSyBG2GXM_DVP8PjNrt8F7GxVnWsFg5bsc0M',
  authDomain: 'broche-ballet-online.firebaseapp.com',
  databaseURL: 'https://broche-ballet-online.firebaseio.com',
  projectId: 'broche-ballet-online',
  storageBucket: 'broche-ballet-online.appspot.com',
  appId: '1:394735594084:web:58a30ccab41cc685400d71',
  measurementId: 'G-YSD5E8G47F'
}

firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const functions = firebase.functions()
if (typeof window !== 'undefined' && /localhost|127\.0\.0\.1/.test(window.location.hostname)) {
  functions.useFunctionsEmulator('http://localhost:5001')
}
const storage = firebase.storage()

export {
  db,
  auth,
  functions,
  storage
}
